import __request__ from "routing/request";
export function administration(JSONbody) {
  return __request__("POST", "/sidecar/administration", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function setAction(JSONbody) {
  return __request__("PUT", "/sidecar/administration/action", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
